export default __webpack_public_path__ + "static/media/hoher_freizeitwert.2081501a.svg";